import { createActionCreators, createReducerFunction } from 'immer-reducer'
import { BasicEntityState } from 'modules/constants'
import { BasicEntityImmerReducer } from 'modules/utils/helpers/BasicEntityImmerReducer'
import { ListResponse } from 'types/api'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  TargetSkuUpdateDTO,
  PedigreedTargetSku,
  PedigreedTargetSkuCreateDTO,
  PedigreedTargetSkuState,
} from '../common/types'

const initialState: PedigreedTargetSkuState = {
  ...BasicEntityState,
  updateCounter: 0,
  totalFarmerOrdersSku: 0,
  totalFarmerOrdersSkuPreviousYear: 0,
  totalGrowerTargets: 0,
  totalTargetValues: 0,
}

type PedigreedMeta = {
  total_target_values: number
  total_farmer_orders_sku: number
  total_farmer_orders_sku_previous_year: number
  total_grower_targets: number
}

class PedigreedTargetSkuReducer extends BasicEntityImmerReducer<
  PedigreedTargetSku,
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  PedigreedTargetSkuCreateDTO,
  TargetSkuUpdateDTO,
  PedigreedTargetSkuState
> {
  updateOccurred() {
    this.draftState.updateCounter += 1
  }
  listRequestSucceed(response: ListResponse<PedigreedTargetSku, PedigreedMeta>) {
    super.listRequestSucceed(response)
    const {
      total_target_values,
      total_farmer_orders_sku,
      total_farmer_orders_sku_previous_year,
      total_grower_targets,
    } = response.meta || {}
    this.draftState.totalTargetValues = total_target_values || 0
    this.draftState.totalFarmerOrdersSku = total_farmer_orders_sku || 0
    this.draftState.totalFarmerOrdersSkuPreviousYear = total_farmer_orders_sku_previous_year || 0
    this.draftState.totalGrowerTargets = total_grower_targets || 0
  }
}

export const PedigreedTargetSkuActions = createActionCreators(PedigreedTargetSkuReducer)
export default PedigreedTargetSkuActions
export const reducer = createReducerFunction(PedigreedTargetSkuReducer, initialState)
